module.exports = __webpack_public_path__ + "img/414.b273504c.png";